/**
 * Help Center Categories — Spanish
 *
 * 8 categorías siguiendo la estructura de Revolut
 */

import {
  AlertTriangle,
  ArrowDownToLine,
  ArrowUpFromLine,
  Percent,
  Receipt,
  Rocket,
  Shield,
  User,
} from "lucide-react";
import type { HelpCategory } from "../../types";

export const HELP_CATEGORIES_ES: HelpCategory[] = [
  {
    id: "getting-started",
    title: "Primeros pasos",
    description: "Todo lo que necesitas para empezar con Supabank",
    icon: Rocket,
    order: 1,
  },
  {
    id: "account",
    title: "Cuenta y perfil",
    description: "Gestiona la configuración de tu cuenta",
    icon: User,
    order: 2,
  },
  {
    id: "deposits",
    title: "Depósitos",
    description: "Cómo depositar criptomonedas en tu cuenta",
    icon: ArrowDownToLine,
    order: 3,
  },
  {
    id: "withdrawals",
    title: "Retiros y pagos",
    description: "Recibe dinero fiat en tu cuenta bancaria",
    icon: ArrowUpFromLine,
    order: 4,
  },
  {
    id: "transactions",
    title: "Transacciones",
    description: "Seguimiento y gestión de tus operaciones",
    icon: Receipt,
    order: 5,
  },
  {
    id: "limits-fees",
    title: "Límites y comisiones",
    description: "Tarifas y límites de operación",
    icon: Percent,
    order: 6,
  },
  {
    id: "security",
    title: "Seguridad",
    description: "Protege tu cuenta",
    icon: Shield,
    order: 7,
  },
  {
    id: "troubleshooting",
    title: "Solución de problemas",
    description: "Respuestas a problemas frecuentes",
    icon: AlertTriangle,
    order: 8,
  },
];

export function getCategoryByIdEs(id: string): HelpCategory | undefined {
  return HELP_CATEGORIES_ES.find((cat) => cat.id === id);
}
